import { useTranslation } from 'react-i18next';
import { Subscription, SubscriptionStatus } from '../../types';
import useAuthState from '../../global-states/useAuthState';
import { Dispatch, SetStateAction, useState } from 'react';

type SubscriptionInfoProps = {
  subscription: Subscription;
  onHandleGetBillingPortal: (
    setDisabled: Dispatch<SetStateAction<boolean>>
  ) => Promise<void>;
};

export const SubscriptionInfo = (props: SubscriptionInfoProps) => {
  const auth: any = useAuthState.getState();
  const [disabled, setDisabled] = useState<boolean>(false);

  const { t } = useTranslation(['onboarding']);

  return (
    <div className='bg-white p-6 rounded-lg mt-7 max-w-2xl'>
      <div className='flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6'>
        <div className='flex flex-col gap-3 flex-1'>
          <div className='flex flex-col sm:flex-row sm:items-center gap-3'>
            <h1 className='text-base font-medium text-gray-900'>
              {t('your_subscription_status.label')}
            </h1>
            <div className='flex items-center'>
              {props.subscription?.status === SubscriptionStatus.active ? (
                <div className='text-green-600 font-semibold'>
                  {t(props.subscription?.status + '.label')}
                </div>
              ) : props.subscription?.status === SubscriptionStatus.trialing ? (
                <div className='rounded-full text-sm flex justify-center items-center text-white bg-droov h-7 px-3'>
                  {t(props.subscription?.status + '.label')}
                </div>
              ) : (
                <div className='rounded-full text-sm flex justify-center items-center text-white bg-red-500 h-7 px-3'>
                  {t(props.subscription?.status + '.label')}
                </div>
              )}
            </div>
          </div>
          <p className='text-sm text-gray-600 leading-relaxed max-w-md'>
            {props.subscription?.status === 'trialing'
              ? t('status_comment_1.label') +
                props.subscription?.current_period_end?.toLocaleDateString(
                  auth?.companyLanguage || 'en-US',
                  {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                  }
                ) +
                t('status_comment_2.label')
              : props.subscription?.status === 'canceled'
              ? t('status_comment_3.label') +
                props.subscription?.canceled_at?.toLocaleDateString(
                  auth?.companyLanguage || 'en-US',
                  {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                  }
                )
              : t('status_comment_4.label') +
                props.subscription?.current_period_end?.toLocaleDateString(
                  auth?.companyLanguage || 'en-US',
                  {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                  }
                )}
          </p>
        </div>
        <div className='flex-shrink-0'>
          <button
            className='blue_button px-6 py-2 whitespace-nowrap'
            disabled={disabled}
            onClick={async () => {
              setDisabled(true);
              await props.onHandleGetBillingPortal(setDisabled);
            }}
          >
            {t('manage_subscription.label')}
          </button>
        </div>
      </div>
    </div>
  );
};
